export function ScoreRing({ score, size = 100, stroke = 8, glow }) {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const offset = circ - (score / 100) * circ;
  const color = score >= 70 ? "#059669" : score >= 40 ? "#D97706" : "#DC2626";
  return (
    <div className="relative" style={{ width: size, height: size }}>
      {glow && <div className="absolute inset-0 rounded-full opacity-20" style={{ background: `radial-gradient(circle, ${color}, transparent 70%)` }} />}
      <svg width={size} height={size} className="transform -rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#E5E7EB" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={color} strokeWidth={stroke} strokeDasharray={circ} strokeDashoffset={offset} strokeLinecap="round" className="transition-all duration-1000" />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="text-3xl font-bold text-[#111827]">{score}</span>
      </div>
    </div>
  );
}
